import React from "react";
import { observer } from "mobx-react";

import { SelectFieldOption } from "./selectFieldOption";
import MultiSelectWithDoDOrdering from "../../../general/MultiSelectWithDoDOrdering";
import FieldToShow from "./FieldsToShowItem";
import { CUBE_QUERY_WIZARD_SQL_QUERY_PART } from "../../../constants/constants-container";

/**
 * @typedef {import("../../../stores/CubeQueryWizard/CubeQueryWizardStore").default} CubeQueryWizardStore
 */

/**
 * Section of QueryWizard that is responsible for "SELECT" in SQL
 *
 * @param {{ store: CubeQueryWizardStore}} props
 * @returns React.Node
 */
const FieldsToShowComponent = ({ store, isRef }) => (
  <section>
    <h4>Attributes to be shown:</h4>
    <div className="items-container">
      {store.keepOrder.length > 0 && (
        <div className="CubeQueryWizard__row header">
          <div className="item-texts">&nbsp;</div>
          <div className="aggregation-function">
            {store.isGroupByUsed && <span>Aggregation fun.</span>}
          </div>
          <div className="alias">Alias</div>
          <div className="group-by">Group by</div>
          <div className="group-by">Show metadata</div>
        </div>
      )}
      <MultiSelectWithDoDOrdering
        options={store.variablesSelectOptions(CUBE_QUERY_WIZARD_SQL_QUERY_PART.SELECT_FIELDS)}
        order={store.keepOrder}
        values={store.keepOrder}
        placeholder="Select attributes to be shown (default is all attributes)..."
        onChangeOrder={store.changeKeepOrder}
        onAdd={store.changeKeepOrder}
        onDelete={store.deleteAllKeepItems}
        components={{ Option: SelectFieldOption }}
        disabled={!isRef && store.hasTemplateRepresentation}
      >
        {store.keepOrder.map((itemKey) => (
          <div key={itemKey} id={itemKey} className="CubeQueryWizard__row item">
            <div
              className="x-icon"
              aria-hidden="true"
              onClick={() => store.deleteKeep(itemKey)}
            >
              ×
            </div>
            <FieldToShow
              cubeName={store.getCubeDetailsByItemKey(itemKey).name}
              isPrimaryCube={
                store.getCubeDetailsByItemKey(itemKey).cubeId ===
                store.cubeDetails.cubeId
              }
              hasForeignCubes={store.hasForeignCubes}
              item={store.cubeStructureItems[itemKey]}
              itemKey={itemKey}
              isEnumerated={store.isEnumerated(itemKey)}
              isGroupByUsed={store.isGroupByUsed}
              groupBy={store.keepState[itemKey].groupBy}
              showMetadata={store.keepState[itemKey].showMetadata}
              alias={store.keepState[itemKey].alias}
              aggregationFunction={store.keepState[itemKey].aggregationFunction}
              onAggregationFunctionChange={store.changeAggregationFunction}
              onAliasChange={store.changeAlias}
              onGroupByChange={store.changeGroupBy}
              onShowMetadataChange={store.changeShowMetadata}
            />
          </div>
        ))}
      </MultiSelectWithDoDOrdering>
    </div>
  </section>
);

export const FieldsToShow = observer(FieldsToShowComponent);
